import { el } from '../utils/dom.js';
import { statusBadgeClass } from '../utils/format.js';

export function statusBadge(status) {
  const cls = statusBadgeClass(status);
  return el('span', { class: `badge ${cls}` }, status || '—');
}
